import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../../../packages/kiti/components/structure/Grid'
import { useComplementaryOptionsGenerator } from '../../../_helpers/complementaryOptions'
import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../../EditableSentence'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import Modal from '../../../../../../components/structure/Modal'
import ProfileSelect from '../../../../../../containers/profiles/select/ProfileSelect'
import SubmitBar from '../../../../../../packages/kiti/components/form/SubmitBar'
import Text from '../../../../../../packages/kiti/components/presentation/Text'

const InsertUserSentence = () => {
  const [open, setOpen] = React.useState()
  const { t } = useTranslation('triggers')
  const { handleChangeIn, form } = useFormState()
  const getComplementaryOptions = useComplementaryOptionsGenerator()

  return (
    <>
      <Text size="h2">: </Text>
      <EditableSentence
        label={form.payload?.name || '_______'}
        truncate={20}
        onClick={() => setOpen(true)}
        field="payload"
      />

      <Modal open={open} onClose={() => setOpen(false)} width="42rem">
        <Grid paddingGutter={0.5} wrap>
          <Col width="50%">
            <FormItem label={t('fields.name')} path={['payload', 'name']} />
          </Col>

          <Col width="50%">
            <FormItem label={t('fields.email')} path={['payload', 'email']} />
          </Col>

          <Col width="50%">
            <FormItem
              label={t('fields.profile')}
              path={['payload', 'profil']}
              Input={ProfileSelect}
              mergedOptions={getComplementaryOptions('profile')}
            />
          </Col>
        </Grid>

        <SubmitBar onClick={() => setOpen(false)} />
      </Modal>
    </>
  )
}

export default InsertUserSentence
